import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextEditorUploadButton from '../text-editor-upload-button';

export default function createUploadButton({ content: Content, tooltipText }) {
  return class UploadButton extends Component {
    static propTypes = {
      onFileChange: PropTypes.func.isRequired,
    };

    render() {
      const {
        onFileChange, // eslint-disable-line no-unused-vars
        ...buttonProps
      } = this.props;

      return (
        <TextEditorUploadButton
          onFileChange={this.props.onFileChange}
          icon={Content}
          tooltipText={tooltipText}
          {...buttonProps}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/create-upload-button.js